import React from "react";
import { Box, Button, Typography, IconButton, Avatar } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import NameLogo from "src/@core/components/icons/Name-Logo";

const DownloadAppBox = ({
  isDownloadBoxVisible,
  isMobile,
  isAppInstalled,
  handleOpenApp,
  handleDownloadApp,
  handleHideBox,
}) => {
  if (!isDownloadBoxVisible || isAppInstalled === null) return null;

  return (
    <Box
      width="100%"
      display={{ xs: "block", sm: "none" }}
      bgcolor="#6e3fc6"
      boxSizing="border-box"
      sx={{ minHeight: 40 }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p="8px 8px"
        boxSizing="border-box"
      >
        <Box display="flex" justifyContent="center" alignItems="center" gap={1}>
          <Avatar
            src="/logo.svg"
            sx={{
              width: 36,
              height: 36,
              bgcolor: "#fff",
              border: "2px solid #A259FF",
              flexShrink: 0,
              padding: 1,
            }}
          >
            <NameLogo size={20} fill="#A259FF" />
          </Avatar>
          <Box>
            <Typography color="#fff" fontSize={12} lineHeight={1}>
              beɘmz
            </Typography>
            <Typography color="#fff" fontSize={12} lineHeight={1}>
              open in the beɘmz app
            </Typography>
          </Box>
        </Box>
        <Box alignContent="center" display="flex" alignItems="center" gap="4px">
          {isMobile && isAppInstalled !== null && (
            <>
              {isAppInstalled ? (
                <Button
                  onClick={handleOpenApp}
                  sx={{
                    fontSize: 12,
                    bgcolor: "#fff",
                    color: "#6e3fc6",
                    borderRadius: "50px",
                    p: "2px 6px",
                    textTransform: "lowercase",
                  }}
                >
                  open
                </Button>
              ) : (
                <Button
                  onClick={handleDownloadApp}
                  sx={{
                    fontSize: 12,
                    color: "#6e3fc6",
                    bgcolor: "#fff",
                    borderRadius: "50px",
                    p: "2px 6px",
                    textTransform: "lowercase",
                  }}
                >
                  download
                </Button>
              )}
            </>
          )}
          <IconButton
            onClick={handleHideBox}
            size="small"
            sx={{ color: "#fff" }}
          >
            <CloseIcon
              fontSize="small"
              sx={{
                bgcolor: "#fff",
                color: "#6e3fc6",
                borderRadius: "50px",
              }}
            />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default DownloadAppBox;
